import { Admin, LoginAdminRequest } from "~/admins/types/auth";
import { AuthenticationResponse } from "~/common/utils/types";
import { api, apiNoInterceptors } from "./axios";

export const getCurrentAdmin = async () => {
  const { data } = await api.get<Admin>("/v1/admins/current");
  return data;
};

export const getAdminIsAuth = async () => {
  const { data } = await api.get<boolean>("/v1/auth/admins");
  return data;
};

export const login = async (payload: LoginAdminRequest) => {
  const response = await apiNoInterceptors.post<AuthenticationResponse>(
    "v1/admins/login",
    payload,
  );
  return response.data;
};

export const resetPassword = async (newPassword: string, token: string) => {
  const response = await api.post<string>(
    "v1/auth/reset-password",
    { password: newPassword },
    {
      headers: {
        token: token,
      },
    },
  );
  return response.data;
};

export const requestEmail = async (email: string) => {
  const response = await api.post<string>(
    "/v1/auth/email/admin/reset-password",
    {
      email,
    },
  );
  return response.data;
};

export const logoutAdmin = async () => {
  const { data } = await api.post<string>("v1/admins/logout");
  return data;
};
